// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__6ax6Y","title":"ClientCherryInfo_title__3jHyJ","itemText":"ClientCherryInfo_itemText__20avw"};